import { BaseMessage } from './base.js';
export class EndSessionMessage extends BaseMessage {
    payload;
    constructor(payload) {
        super(payload);
        this.payload = payload;
    }
    get userId() {
        return this.payload.userId;
    }
    get userName() {
        return this.payload.userName;
    }
    get channelId() {
        return this.payload.channelId;
    }
}
